import React, { useState, useEffect } from 'react'
import OpenInFullOutlinedIcon from '@mui/icons-material/OpenInFullOutlined';
import { FaExpandAlt } from 'react-icons/fa';
import PrioritiydataScheduleDetails from './PrioritiydataScheduleDetails';
import axios from "axios";
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';



const PrioritiydataSchedule = ({ currentIterationUUID }) => {
    const params = useParams();
    const moduleUUID = params?.uuid;
    const userData = useSelector(state => state.userSlice);
    const configData = useSelector((state) => state.configSlice);
    const [ dataSchedule, setDataSchedule] = useState(false);
    const [ priorityTable , setPriorityTable ] = useState([]);
    const [ taskSummary , setTaskSummary ] = useState({});


    const ShceduleDetail = () => {
        setDataSchedule(true)
    }


    useEffect(()=>{
        if(currentIterationUUID?.value?.length > 0){
            if(currentIterationUUID?.mode =="UNGUIDED" ){
                getPriorityDataSummary(currentIterationUUID?.value);
            }
        }
    },[currentIterationUUID]);

    const getPriorityDataSummary=async(iterationId)=>{
       
        const priorityDataSummary = await axios.get(`${configData.config.API_URL}/api/analytics/session/priority-table/${moduleUUID}/${iterationId}`,{
            headers: {
                Authorization: `Bearer ${userData.token}`,
              }
        });
        setPriorityTable([...priorityDataSummary?.data?.data?.priorityTable]);
        setTaskSummary({...priorityDataSummary?.data?.data?.taskSummary});
    }




    return (
        <>
            <div className="card py-4 h-100 for_predictive">
              
                    <div className="anydetail-box">
                        <div className='prioritydataschedule position-relative'>
                            <h5>Priority Data Schedule</h5>
                            <div className='d-flex align-item-center justify-content-between'>
                                <div className="d-flex align-item-center justify-content-between flex-column gap-3">
                                    <p>No. of total task : {currentIterationUUID?.mode =="UNGUIDED" ? <span>  {taskSummary.totalTasks} </span> : "NA" } </p>
                                    <p className='mb-0'>No. of critical steps : {currentIterationUUID?.mode =="UNGUIDED" ?   <span> {taskSummary.criticalTasks} </span> : "NA" } </p>
                                </div>
                                <div className="d-flex align-item-center justify-content-between flex-column">
                                    <p>Performance Score : {currentIterationUUID?.mode =="UNGUIDED" ?   <span> {taskSummary.score}% </span> : "NA" } </p>
                                    <p className='mb-0'>No. of Wrong attempts : {currentIterationUUID?.mode =="UNGUIDED" ?   <span> {taskSummary.wrongAttempts} </span> : "NA" } </p>
                                </div>
                            </div>

                            {currentIterationUUID?.mode =="UNGUIDED" &&
                                <span className='expandrf cursor-pointer' onClick={ShceduleDetail} ><FaExpandAlt /></span>
                            }

                        </div>
                    </div>
              
            </div>

            <PrioritiydataScheduleDetails show={dataSchedule} handleClose={() => setDataSchedule(false)} priorityTable={priorityTable} taskSummary={taskSummary} />
        </>
    )
}

export default PrioritiydataSchedule
